import styled, { css } from 'styled-components';

import { Button } from '@xsolla/ui-core';

import { CommonClickAction, VerticalHorizontalCenterColumnBlock } from '../../../styled';

export const OauthSettingsWrapper = styled.div`
  max-width: 468px;
  margin-bottom: 32px;
`;

export const Oauth2SettingsTitle = styled.h1`
  text-align: center;
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const Oauth2SettingsSubtitle = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.muted};
  text-align: center;
`;

// Table styles

export const TableBlock = styled.div`
  margin-bottom: 32px;
`;

const TableTextStyles = css`
  font-size: 14px;
  line-height: 24px;
  padding-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ClientName = styled.p`
  ${TableTextStyles};
`;

export const ClientId = styled.p`
  ${TableTextStyles};
  font-weight: 700;
`;

export const ClientSecret = styled.p`
  ${TableTextStyles};
  font-weight: 700;
  color: ${(props) => props.theme.colors.brand};

  display: flex;
  align-items: center;

  ${CommonClickAction};
`;

export const UpdateOauth = styled.div`
  ${CommonClickAction};
  color: ${(props) => props.theme.colors.muted};
`;

export const AddOAuthButtonWrap = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;

export const ExtraButton = styled(Button)`
  ${CommonClickAction};
`;

export const EmptyTableWrapper = styled(VerticalHorizontalCenterColumnBlock)`
  height: 166px;
`;
